import React from "react";
import TreeList, { Column, SearchPanel, Paging } from "devextreme-react/tree-list";
import "./CreditData.css";

import { formatCell } from '../../utils/formatUtils';

interface CreditRow {
  id: number;
  parentId: number;
  name: string;
  country: string;
  continent: string;
  region: string;
  sector: string;
  industry: string;
  rating: string;
  pd: number;
  lgd: number;
  ul: number;
  el: number;
  ead: number;
  ce: number;
  pfe: number;
  mtm_cfp: number;
  mtm_client: number;
  settlement: number;
  collateral: number;
}

// Mock data
const sampleData: CreditRow[] = [
  {
    id: 1,
    name: "RMS Total",
    parentId: 0,
    country: "",
    continent: "",
    region: "",
    sector: "",
    industry: "",
    rating: "",
    pd: 0,
    lgd: 40,
    ul: 1725978,
    el: 276688,
    ead: 50610452,
    ce: 50610452.21,
    pfe: 0,
    mtm_cfp: 7006926.701,
    mtm_client: -7006926.701,
    settlement: 0,
    collateral: -4814028.25,
  },
  {
    id: 2,
    parentId: 0,
    name: "AAK",
    country: "Sweden",
    continent: "Europe",
    region: "Northern Europe",
    sector: "Agriculture",
    industry: "Agriculture",
    rating: "A",
    pd: 0,
    lgd: 40,
    ul: 0,
    el: 18,
    ead: 91374,
    ce: 0,
    pfe: 0,
    mtm_cfp: -28000,
    mtm_client: 28000,
    settlement: 0,
    collateral: 0,
  },
  {
    id: 3,
    parentId: 0,
    name: "ADM International",
    country: "USA",
    continent: "North America",
    region: "USA",
    sector: "Accommodation and Food Services",
    industry: "Food & Beverage",
    rating: "A-",
    pd: 0,
    lgd: 40,
    ul: 1349,
    el: 30,
    ead: 150900,
    ce: 150900,
    pfe: 0,
    mtm_cfp: 150900,
    mtm_client: -150900,
    settlement: 0,
    collateral: 0,
  },
];


const CreditData: React.FC = () => {
  return (
    <div className="credit-container">
      <TreeList
        dataSource={sampleData}
        keyExpr="id"
        parentIdExpr="parentId"
        showBorders={true}
        autoExpandAll={true}
        columnAutoWidth={true}
        wordWrapEnabled={true}
        showRowLines={true}
        showColumnLines={true}
        rowAlternationEnabled={true}
        height={500}
        headerFilter={{ visible: true }}
        scrolling={{ mode: "virtual" }}
        focusedRowEnabled={false}
      >
        <SearchPanel visible={true} />
        <Paging enabled={false} />

        {/* First column */}
        <Column dataField="name" caption="Book" width={220} fixed={true} />

        {/* Basic info */}
        <Column dataField="country" caption="Country" width={120} />
        <Column dataField="continent" caption="Continent" width={120} />
        <Column dataField="region" caption="Region" width={140} />
        <Column dataField="sector" caption="Sector" width={180} />
        <Column dataField="industry" caption="Industry" width={180} />
        <Column dataField="rating" caption="Internal Rating" width={120} />
        <Column dataField="pd" caption="Probability of default" width={140} />
        <Column dataField="lgd" caption="Loss Given Default" width={140} />

        {/* Loss metrics */}
        <Column dataField="ul" caption="Unexpected Loss (UL)" width={140} cellRender={({ value }: { value: number }) => formatCell(value)} />
        <Column dataField="el" caption="Expected Loss (EL)" width={140} cellRender={({ value }: { value: number }) => formatCell(value)} />
        <Column dataField="ead" caption="Exposure at default (EAD)" width={160} cellRender={({ value }: { value: number }) => formatCell(value)} />

        {/* Exposures */}
        <Column dataField="ce" caption="Current exposure (CE)" width={160} cellRender={({ value }: { value: number }) => formatCell(value)} />
        <Column dataField="pfe" caption="Potential Future Exposure (PFE)" width={160} cellRender={({ value }: { value: number }) => formatCell(value)} />

        {/* MTM */}
        <Column dataField="mtm_cfp" caption="MTM (CFP)" width={150} cellRender={({ value }: { value: number }) => formatCell(value)} />
        <Column dataField="mtm_client" caption="MTM (client side)" width={160} cellRender={({ value }: { value: number }) => formatCell(value)} />

        {/* Settlement / Collateral */}
        <Column dataField="settlement" caption="Settlement amount" width={160} cellRender={({ value }: { value: number }) => formatCell(value)} />
        <Column dataField="collateral" caption="Collateral" width={160} cellRender={({ value }: { value: number }) => formatCell(value)} />
      </TreeList>
    </div>
  );
};

export default CreditData;
